var $70e3a4dcafe2cf52$exports = {};
$70e3a4dcafe2cf52$exports = {
    "pending": `in sospeso`
};


export {$70e3a4dcafe2cf52$exports as default};
//# sourceMappingURL=it-IT.mjs.map
